import React, { useEffect, useState } from 'react';

// Stylesheet import
import classes from '../DeleteElement/DeleteElement.module.css';

// Icon import from Feather icon
import { Edit } from 'react-feather';

import { useDispatch } from 'react-redux';
import AcknowledgementModal from '../../../../Navbar/NavbarRight/ContentTypeModal/UploadContentModal/Utilities/AcknowledgementModal/AcknowledgementModal';
import { handleModalType, handleIsEditing, handleDetails } from '../../../../../Store/uploadContentSlice';

// Import for the modalTypes Object
import { modalTypes } from '../../../../../Constants/ContentUpload';
import API from '../../../../../Axios/axios';
import { apiErrorCodes } from '../../../../../apiErrorCodes';
import { useNavigate } from 'react-router-dom';


function EditPostElement(props) {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [acknowledgementModal, setAcknowledgementModal] = useState(false);

  const fetchCategories = async () => {
    let postDetailsCategories = [];
    try {
      const response = await API.get('/core/interests/', {
        headers: {
          Authorization: `token ${localStorage.getItem('token')}`,
        },
      });
      if (response.data.code === apiErrorCodes.SUCCESS) {
        // update categories list for post update
        const categories = props.postData.category.map((categoryName) => response.data.message.find(mainCategory => mainCategory.name.toLowerCase() === categoryName.toLowerCase()))
        postDetailsCategories = categories.filter(Boolean);
      }
    } catch (error) {
      console.log(error)
      if (
        error?.response?.data?.code === apiErrorCodes.AUTHENTICATION_FAILED ||
        error?.response?.data?.code === apiErrorCodes.NOT_AUTHENTICATED ||
        error?.response?.data?.code === apiErrorCodes.INVALID_TOKEN ||
        error?.response?.data?.code === apiErrorCodes.ACCOUNT_NOT_EXIST
      ) {
        localStorage.removeItem('token');
        navigate('/entry/signin');
      }
    }
    return postDetailsCategories;
  }


  const editPostHandler = async () => {
    //  start post edit process
    const postDetails = {
      postDescription: props.postData.text,
      categories: await fetchCategories(),
      projectTitle: props.postData.project_title
    }

    dispatch(handleIsEditing(JSON.stringify({ isEditing: true, editedPostId: props.postData.id })));
    dispatch(handleDetails(JSON.stringify(postDetails)));
    dispatch(handleModalType(modalTypes.DETAILS));
    // dispatch(handleContentType());
  };

  return (
    <>
      {acknowledgementModal && (
        <AcknowledgementModal
          setAcknowledgementModal={setAcknowledgementModal}
          message="Post updated succesfully."
        />
      )}
      <div className={props?.className} onClick={editPostHandler}>
        <Edit className={classes.icon} />
        <p style={{ display: 'contents' }} className="element-heading">
          Edit
        </p>
      </div>

    </>
  );
}

export default EditPostElement;
